module.exports = __webpack_public_path__ + "static/img/cchead.f3b69b3e.jpg";